/**
 * 品牌商标列表页
 */
export const BRAND_LIST_PAGE_PATH = '/brand/list'

/**
 * 品牌商标新增页
 */
export const BRAND_CREATE_PAGE_PATH = '/brand/create'

/**
 * 品牌商标编辑页
 */
export const BRAND_EDIT_PAGE_PATH = '/brand/edit'

/**
 * 品牌商标详情页
 */
export const BRAND_DETAIL_PAGE_PATH = '/brand/detail'
